import { logger } from '../utils/logger';

async function get(
  authURL: string,
  selectedClient: string,
  teamId: string,
  token: string,
  startDate: Date,
  endDate: Date
) {
  return await fetch(
    `${authURL}/clients/${selectedClient}/team/${teamId}/totalChats?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
}

export default async function getTotalChats(
  authURL: string,
  selectedClient: string,
  teamId: string,
  token: string,
  startDate: Date,
  endDate: Date
) {
  try {
    const response = await get(
      authURL,
      selectedClient,
      teamId,
      token,
      startDate,
      endDate
    );
    if (response.ok) {
      const totalChats = (await response.json()) as { count: number };
      return totalChats;
    } else {
      const error = (await response.json()) as { message: string };
      logger(error.message);
    }
  } catch (e) {
    logger(e);
  }
}
